import { l } from '@manychat/manyui'

import { ReasonStatuses } from 'common/oneTimeNotify/constants/notifyReasonConstants'
import { getReasonTypeLabel } from 'common/oneTimeNotify/utils'
import { NotificationReason } from 'shared/api/common/schemas/notificationReason'

import { SelectOption } from './interfaces'
import { Option, OptionsGroup, OptionType, TopicOptionValue } from './options'

export const getReasonTitleForDropdown = (reason: NotificationReason): string => {
  return reason.status === ReasonStatuses.ARCHIVE
    ? reason.caption + ` (${l.translate('Archived')})`
    : reason.caption
}

const getReasonLabel = (reason: TopicOptionValue): string => {
  return getReasonTypeLabel(reason.type, reason.channel).toLowerCase()
}

export const transformAssigneeOptions = (
  groups: OptionsGroup[],
  isMessageTagsSunsetEnabled: boolean,
): SelectOption[] => {
  return groups.reduce<SelectOption[]>((acc, group) => {
    acc.push({
      label: group.label,
      value: group.value,
      type: 'group',
    })

    const children = group.options.map((option) => {
      const isDeprecated = option.value.optionType === OptionType.TAG && isMessageTagsSunsetEnabled
      return {
        label: option.label,
        value: 'id' in option.value ? option.value.id.toString() : option.value.toString(),
        rightContent: 'type' in option.value ? getReasonLabel(option.value) : undefined,
        type: option.value.optionType,
        isDeprecated,
        disabled: isDeprecated,
      }
    })

    return acc.concat(children)
  }, [])
}

export const parseSelectedOptionValue = (
  selectedOption: Option,
): { label: string; value: string } => {
  return {
    label: selectedOption.label,
    value: 'id' in selectedOption.value ? selectedOption.value.id : '',
  }
}
